'use strict';

import React, { Component } from 'react';

import MapLeaflet  from '../../../../global/mapReactLibrary/MapLeaflet.jsx'
import { ListItem, ListItemText, ListItemIcon, IconButton, Button, Box, TableBody, TableRow, TableCell } from '@material-ui/core';
import { Close, Group, Create, PinDrop } from '@material-ui/icons';
import { MiniCard } from '../../../commonModules/layouts/CardPage.jsx';
import { TableLayout } from '../Stock/containers/Layout.jsx';
import InputText from '../../../commonModules/interface/form-input-inline.jsx';

class Geolocalisation extends Component{
    state = {
        update: false,
        errorMSG: '',

        lat: 0.0,
        long: 0.0,
    }

        
    saveInfo = async(e) =>  {
        e.preventDefault();
        //Check data
        if (isNaN(this.state.lat)){
            this.setState({errorMSG: 'La lattitude doit être un nombre'})
            return
        }
        if (isNaN(this.state.long)){
            this.setState({errorMSG: 'La longitude doit être un nombre'})
            return
        }
        this.setState({errorMSG: ''})
        //
        console.log("[INFO], Is a number lat ,", this.state.lat, " lont ",this.state.long)

        var url = "/geolocalisation/info/update?boxAssoId=" + this.props.boxAssoId;
        try {
            const req = await fetch(url,{
                method:'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content,
                },
                body: JSON.stringify({
                    lat: parseFloat(this.state.lat),
                    long:  parseFloat(this.state.long),
                }),
                credentials: 'same-origin',
       
            })
            const res = await req.json()
            console.log({res});
            
            if(res.error === "OK"){
                this.setState({update:false});
            } else {
                console.log("[ERROR] handleUpdateCustom ", res.error);
                this.setState({errorMSG: 'ERROR'})
            }
        } catch (error) {
            console.log('====================================');
            console.log("[ERROR] handleUpdateCustom ", error);
            console.log('====================================');
            this.setState({errorMSG: 'BIG ERROR'})
        }

    }
    componentDidMount = async () =>  {
        var url = "/geolocalisation/info?boxAssoId=" + this.props.boxAssoId;
        try {
            let req = await fetch(url,{
                method:'GET',
                headers: {
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content,
                },
                credentials: 'same-origin',
       
            })
            const res = await req.json()
            console.log({res});
            
            if(res.error === "OK"){
                this.setState({lat: res.lat,
                    long: res.long,});
            } else {
                // this.notif("danger", res.content, "Erreur")
                console.log("[ERROR] handleSubmitCustom ", res.error);
            }
        } catch (error) {
            // this.notif("danger", error, "Erreur")
            console.log('====================================');
            console.log("[ERROR] handleSubmitCustom ", error);
            console.log('====================================');
        }
    }
    componentWillUnmount() {
      try{
      }catch(e){
        console.log(e);
      }
    }
    render() {

        return (
            <MiniCard 
                title="Géolocalisation"
                action={
                    <IconButton onClick={() => this.setState({ update: !this.state.update})} color="primary" >
                        {this.state.update ? <Close /> : <Create />}
                    </IconButton>
                }
                avatar={<PinDrop />}
            >
            <Box>
                {!this.state.update &&
                    <TableLayout>
                        <TableBody>
                            <TableRow>
                                <TableCell component="th">Lattitude</TableCell>
                                <TableCell>{this.state.lat}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell component="th">Longitude</TableCell>
                                <TableCell>{this.state.long}</TableCell>
                            </TableRow>
                            {/* <TableRow>
                                <TableCell colSpan={2}>
                                    {this.state.lat !== 0 && this.state.long !== 0&&

                                        <MapLeaflet 
                                            lat={this.state.lat} 
                                            lng={this.state.long} 
                                            paygoMapList={[
                                                {boxId: this.props.userId,
                                                longitude: this.state.long,
                                                latitude: this.state.lat,
                                            }]} 
                                        />
                                    }
                                </TableCell>
                            </TableRow> */}
                        </TableBody>
                    </TableLayout>

                }

                {this.state.update &&
                <Box>
                    <TableLayout>
                        <TableBody>
                            <TableRow>
                                <TableCell>
                                    <InputText label="Lattitude" type="text" value={this.state.lat} onChange={(e) => this.setState({lat:e.target.value})} 
                                    />
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell>
                                    <InputText label="Longitude" type="text" value={this.state.long} onChange={(e) => this.setState({long:e.target.value})} />
                                </TableCell>
                            </TableRow>
                            {this.state.errorMSG &&
                            <TableRow>
                                <TableCell>
                                {this.state.errorMSG}
                                </TableCell>
                            </TableRow>
                            }
                        </TableBody>
                    </TableLayout>
                    <Box>
                        <Button variant="contained" color="primary" onClick={this.saveInfo}>Valider</Button>
                        <Button onClick={() => this.setState({ update: false })}>Cancel</Button>
                    </Box>
                </Box>
                }   
                </Box>
            </MiniCard>
        )
    }
};
export default Geolocalisation
